<script lang="ts">
    import Icon from "../../widgets/Icon.svelte"
    import { mdiTimer } from "@mdi/js"
    import { icons, operationSources } from "../../../config"
    import { _ } from "svelte-i18n"

    export let type = 1
    export let sharedView: boolean = false

    let opSourceCodes = Object.keys(operationSources)
        .map(Number)
        .sort((a, b) => a - b)
</script>

<div class="legends">
    <!-- Legende -->
    <div class="legend">
        <div class="headline">{$_("operationsLegend.legendTitle")}</div>
        <div class="items">
            {#if !sharedView}
                <section>
                    {#each opSourceCodes as code}
                        <div class="item">
                            <div class="icon">
                                <img
                                    src="{operationSources[code].img}"
                                    alt="{operationSources[code].label}"
                                    width="24"
                                />
                            </div>
                            <div class="text">{operationSources[code].label}</div>
                        </div>
                    {/each}
                </section>
            {/if}
            {#if type == 1}
                <section>
                    <div class="item">
                        <div class="icon"><span class="state grey"></span></div>
                        <div class="text">{$_("operationsLegend.createdOperation")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <span class="state yellow"></span>
                        </div>
                        <div class="text">{$_("operationsLegend.inProgress")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <span class="state green"></span>
                        </div>
                        <div class="text">{$_("operationsLegend.offerCreated")}</div>
                    </div>
                </section>
            {:else if type == 2}
                <section>
                    <div class="item">
                        <div class="icon">
                            <span class="state storno">S</span>
                        </div>
                        <div class="text">{$_("operationsLegend.cancellation")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <span class="state teilstorno">TS</span>
                        </div>
                        <div class="text">{$_("operationsLegend.partialCancellation")}</div>
                    </div>
                </section>
            {/if}
        </div>
    </div>

    {#if type == 2}
        <!-- Legende -->
        <div class="legend">
            <div class="headline">{$_("operationsLegend.statusDescriptionTitle")}</div>
            <div class="items">
                <section>
                    <div class="item">
                        <div class="icon"><span class="state grey"></span></div>
                        <div class="text">{$_("operationsLegend.notStarted")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <span class="state yellow"></span>
                        </div>
                        <div class="text">{$_("operationsLegend.inProcess")}</div>
                    </div>
                    <div class="item">
                        <div class="icon"><span class="state red"></span></div>
                        <div class="text">{$_("operationsLegend.delayed")}</div>
                    </div>
                </section>
                <section>
                    <div class="item">
                        <div class="icon">
                            <span class="state split"><span class="left"></span><span class="right"></span></span>
                        </div>
                        <div class="text">{$_("operationsLegend.partlyDone")}</div>
                    </div>
                    <div class="item">
                        <div class="icon">
                            <span class="state green"></span>
                        </div>
                        <div class="text">{$_("operationsLegend.completed")}</div>
                    </div>
                </section>
                <section>
                    <div class="legend_flex">
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon
                                    path="{icons.confirmation}"
                                    size="20px"
                                    viewBox="0 0 20 20"
                                    color="#9A9A9A"
                                /></span
                            >
                        </div>
                        <div class="legend_icon">
                            <span class="icon"><Icon path="{mdiTimer}" color="#9A9A9A" /></span>
                        </div>
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon
                                    path="{icons.manufacture}"
                                    size="18px"
                                    viewBox="0 0 18 18"
                                    color="#9A9A9A"
                                /></span
                            >
                        </div>
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon
                                    path="{icons.readyToShip}"
                                    size="20px"
                                    viewBox="0 0 20 20"
                                    color="#9A9A9A"
                                /></span
                            >
                        </div>
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon path="{icons.shipping}" size="20px" viewBox="0 0 20 20" color="#9A9A9A" /></span
                            >
                        </div>
                    </div>
                    <div class="legend_flex flex2">
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon
                                    path="{icons.confirmation}"
                                    size="20px"
                                    viewBox="0 0 20 20"
                                    color="#9A9A9A"
                                /></span
                            ><span class="text">{$_("operationsLegend.orderConfirmation")}</span>
                        </div>
                        <div class="legend_icon">
                            <span class="icon"><Icon path="{mdiTimer}" color="#9A9A9A" /></span><span class="text"
                                >{$_("operationsLegend.objectionPeriod")}</span
                            >
                        </div>
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon
                                    path="{icons.manufacture}"
                                    size="18px"
                                    viewBox="0 0 18 18"
                                    color="#9A9A9A"
                                /></span
                            ><span class="text">{$_("operationsLegend.manufacture")}</span>
                        </div>
                        <div class="legend_icon">
                            <span class="icon"><img src="assets/img/icons/Versand.svg" alt="" /></span><span
                                class="text">{$_("operationsLegend.shipping")}</span
                            >
                        </div>
                        <div class="legend_icon">
                            <span class="icon"
                                ><Icon path="{icons.shipping}" size="20px" viewBox="0 0 20 20" color="#9A9A9A" /></span
                            ><span class="text">{$_("operationsLegend.delivery")}</span>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    {/if}
</div>
